<template>
  <v-layout 
    class="mb-5"
    row>
    <v-flex
      xs12
      md6
      offset-md3>
      <v-toolbar
        flat
        color="white">
        <v-toolbar-title>Demnächst verfügbar</v-toolbar-title>
      </v-toolbar>
      <v-card
        flat>
        <!-- <v-card-title primary-title> -->
        <v-divider class="mx-3"></v-divider>
        <v-card-text
          style="overflow: hidden; text-overflow: ellipsis;">
          <div>
            <v-layout
              row
              wrap>
              <!-- <v-flex
                xs12
                class="font-weight-bold text-xs-left">
                ToDo-Liste und Übersicht über anstehende Verbesserungen, auf welche ihr euch demnächst freuen könnt.
              </v-flex>
              -->
              
              <v-flex
                xs12>
                <span>ToDo-Liste und Übersicht über anstehende Verbesserungen, auf welche ihr euch demnächst freuen könnt. </span>
              </v-flex>
              <!-- <v-flex
                xs12
                class="mt-1">
                <div class="caption font-italic">
                  Zudem seht ihr, woran gerade gearbeitet wird.
                </div>
              </v-flex> -->
            </v-layout>
          </div>
        </v-card-text>
       
        <!-- <v-divider></v-divider> -->
        <!-- </v-card-title> -->
      </v-card>

      <app-settings-todo-card
        v-for="(item, index) in orderedTodos"
        :key="index"
        :item="item"
        :index="index">
      </app-settings-todo-card>
    </v-flex>
  </v-layout>
</template>



<script>
import SettingsToDoCard        from '@/components/View_Profile/SettingsToDo_Card'

import { mapState } from 'vuex'
import { orderBy } from 'lodash'


export default {
  components: {
  // eslint-disable-next-line
    'app-settings-todo-card': SettingsToDoCard,
  },
  computed: {
    ...mapState({
      todos: state => state.todos
    }),
    orderedTodos: function() {
      return orderBy(this.todos, [
        'status',
        'desc'
      ],[
        'order',
        'desc'
      ])
    }
  },
  mounted() {

    this.toTop()
   
  },
  methods: {
    toTop() {
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
    }
  
  }
}
</script>
